// ModalEditarContato.jsx
import React from "react";
import { Modal, Form, Input, Button } from "antd";
import ReactInputMask from "react-input-mask";

const ModalEditarContato = ({
  isModalEdit,
  setIsModalEdit,
  form,
  isLoading,
  contatoSelecionado,
  onAtualizarContato, // função passada pelo componente pai
}) => {
  return (
    <Modal
      open={isModalEdit}
      title="Editar Contato"
      onCancel={() => {
        setIsModalEdit(false);
        form.resetFields();
      }}
      footer={null}
    >
      <Form layout="vertical" form={form}>
        <Form.Item
          label="Nome"
          name="nome"
          rules={[{ required: true, message: "Digite o nome do contato" }]}
        >
          <Input placeholder="Ex: João Silva" />
        </Form.Item>

        <Form.Item
          label="E-mail"
          name="email"
          rules={[
            { required: true, message: "Digite o e-mail do contato" },
            { type: "email", message: "Digite um e-mail válido" },
          ]}
        >
          <Input placeholder="Ex: joao@email.com" />
        </Form.Item>

        <Form.Item
          label="Telefone"
          name="telefone"
          rules={[{ required: true, message: "Digite o telefone do contato" }]}
        >
          <ReactInputMask mask="(99) 99999-9999" maskChar={null}>
            {(inputProps) => <Input {...inputProps} placeholder="Ex: (11) 99999-9999" />}
          </ReactInputMask>
        </Form.Item>

        <Form.Item>
          <Button
            type="primary"
            loading={isLoading}
            onClick={() => onAtualizarContato(contatoSelecionado?.id)}
            block
          >
            Salvar Alterações
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ModalEditarContato;
